import React, {useRef, useState} from 'react';
import {View, ScrollView, Platform} from 'react-native';
import {Breadcrumbs} from '../../shared/components/breadcrumbs';
import {useSelector} from 'react-redux';
import {profileHolderVolunteerIdSelector} from '../../redux/selectors/profile';
import {ResponsiveView} from '../../shared/components/responsiveView';
import Screen from '../../shared/components/screen';
import {Text} from '../../shared/components/text';
import {Routes, Screens} from '../../shared/routing';
import {DeviceSize} from '../../shared/theme/helpers';
import {ContentWithRightImage} from '../../shared/components/contentWithRightImage';
import {Volunteers} from '../../assets/images';
import {ViewProps} from './model';
import {useIsDesktop} from '../../shared/hooks/useIsDesktop';
import {useVolunteersServiceStyles} from './styles';
import {Login} from './components/login';
import {Link} from '../../shared/components/link';
import {VolunteersServiesProfile} from './components/volunteersProgram/VolunteersServiceProfile';
import {DobroWebView} from './components/dobroWebView';
import {Image} from '../../shared/components/image';

const routes = [
  {
    title: 'Возможности карты',
    routeName: Screens.CardServices,
    webRoute: Routes.cardService,
  },
  {
    title: 'Волонтерство',
    routeName: Screens.VolunteersService,
    webRoute: Routes.volunteersService,
  },
];

export default ({link}: ViewProps) => {
  const volunteerId = useSelector(profileHolderVolunteerIdSelector);
  const styles = useVolunteersServiceStyles();
  const isDesktop = useIsDesktop();
  const scrollViewRefWeb = useRef<ScrollView>(null);
  const scrollViewRefMob = useRef<ScrollView>(null);
  const [nestedComponentCoordinates, setNestedComponentCoordinates] = useState({x: 0, y: 0});

  const scrollToNestedComponent = () => {
    if (scrollViewRefWeb.current && Platform.OS === 'web') {
      scrollViewRefWeb.current.scrollTo({
        x: nestedComponentCoordinates.x,
        y: nestedComponentCoordinates.y,
        animated: true,
      });
      return;
    }
    if (scrollViewRefMob.current && Platform.OS !== 'web') {
      scrollViewRefMob.current.scrollTo({
        x: nestedComponentCoordinates.x,
        y: nestedComponentCoordinates.y,
        animated: true,
      });
    }
  };
  if (link) {
    return <DobroWebView link={link} />;
  }

  return (
    <Screen fullWidth scrollViewRef={scrollViewRefWeb} style={{maxHeight: Platform.OS === 'web' ? undefined : 750}}>
      <ScrollView contentInsetAdjustmentBehavior='automatic' ref={scrollViewRefMob}>
        <View style={styles.root}>
          <View style={styles.content}>
            <Breadcrumbs routes={routes} />
            <ContentWithRightImage
              contentStyle={styles.rightImage}
              icon={<Image source={Volunteers as any} width={450} height={400} />}
              hideImage={!isDesktop}>
              {volunteerId ? (
                <VolunteersServiesProfile
                  setNestedComponentCoordinates={setNestedComponentCoordinates}
                  scrollToNestedComponent={scrollToNestedComponent}
                />
              ) : (
                <>
                  <ResponsiveView only={[DeviceSize.desktop]}>
                    <Text testID='volunteers-title-id' style={styles.title} type='h2'>
                      Волонтерство
                    </Text>
                  </ResponsiveView>
                  <Text testID='volunteers-description-title-id' style={styles.descriptionTitle}>
                    Единая социальная карта Свердловской области позволяет волонтерам быть в курсе всех событий сферы
                    добровольчества в Свердловской области.
                  </Text>
                  <Text testID='volunteers-description-body-id' style={styles.descriptionBody}>
                    Все актуальные события, которые проводятся в регионе для добровольцев (по данным портала{' '}
                    <Link external href='https://dobro.ru/' testID='volunteers-dobroru-href'>
                      <Text style={styles.link}>Добро.рф</Text>
                    </Link>
                    ), будут отражаться в вашей новостной ленте.
                  </Text>
                  <Login />
                </>
              )}
            </ContentWithRightImage>
          </View>
        </View>
      </ScrollView>
    </Screen>
  );
};
